<template>
    <div class="row">
        <div class="col">
            <search scope="mine" :context="false"></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from '../data/statements/Result'
    import Search from '../data/statements/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
